import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";

import type {
	DealVendorNote,
	DealVendorNoteTemplate
} from "~/models/DealVendorNote";

const paths = {
	show: "vendors/deals/:deal_id/deal_vendor_notes/:id",
	template: "vendors/deals/:deal_id/deal_vendor_notes/template"
};

type TShow = (
	dealId: number | null,
	id: number | null
) => SwrReturnType<DealVendorNote>;
type TTemplate = (
	dealId: number | null
) => SwrReturnType<DealVendorNoteTemplate>;
type ReturnType = {
	show: TShow;
	template: TTemplate;
};

export const useDealVendorNotes = (): ReturnType => {
	const show: TShow = (dealId: number | null, id: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isLoading } = useSWR<DealVendorNote>(
			id === null
				? null
				: paths.show
						.replace(":deal_id", String(dealId))
						.replace(":id", String(id))
		);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	const template: TTemplate = (dealId: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isLoading } = useSWR<DealVendorNoteTemplate>(
			paths.template.replace(":deal_id", String(dealId))
		);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	return { show, template };
};
